export const DB_NAME = "canvasElementsDB";
export const DB_VERSION = Number(localStorage.getItem("canvasDBVersion")) || 6; // Bump this in one place only!
export const STORES = [
  "canvasElements",
  "offCanvasElements",
  "canvasMarkers",
  "stepDrafts",
  "partDetails",
];

export const MAX_DB_VERSION_TRIES = 10;
export const STORE_NAME = "canvasElements";
export const DEFAULT_TIMEOUT = 5000;
